import { Box } from '@mui/material';
import { Subheading } from '@natomalabs/natomui/src/components/Typography';
import LoadingAnimation from './SvgLoadingAnimation';

export default function LoadingState() {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: theme.palette.foamGreen['600']
      })}
      data-testid="LoadingState-root"
    >
      <Box sx={(theme) => ({ marginBottom: theme.spacing(4) })}>
        <Subheading sx={(theme) => ({ color: theme.palette.text.secondary })}>
          loading…
        </Subheading>
      </Box>
      <LoadingAnimation height={128} width={128} />
    </Box>
  );
}

export const testIds = {
  loadingState: 'LoadingState-root'
};
